import { Pipe, PipeTransform } from '@angular/core';
import { AssetType } from '../../domain/models';

/**
 * Pipe to get icon path for asset type
 * Returns paths to custom PNG icons in public folder
 */
@Pipe({
  name: 'assetIcon',
  standalone: true,
})
export class AssetIconPipe implements PipeTransform {
  transform(assetType: AssetType): string {
    // Map asset types to custom icon paths
    const iconMap: Record<AssetType, string> = {
      [AssetType.REFINERY]: '/icons/oil-factory.png',
      [AssetType.UNIT]: '/icons/unit.png',
      [AssetType.TANK]: '/icons/tank.png',
      [AssetType.PIPELINE]: '/icons/pipeline.png',
      [AssetType.FLOWMETER]: '/icons/flowmeter.png',
      [AssetType.EQUIPMENT]: '/icons/unit.png',
      [AssetType.SENSOR]: '/icons/flowmeter.png',
      [AssetType.CONTROLLER]: '/icons/unit.png',
      [AssetType.PROCESS]: '/icons/unit.png',
      [AssetType.STREAM]: '/icons/stream.png',
      [AssetType.DATABASE]: '/icons/unit.png',
      [AssetType.TABLE]: '/icons/unit.png',
      [AssetType.VIEW]: '/icons/unit.png',
      [AssetType.COLUMN]: '/icons/flowmeter.png',
      [AssetType.DOCUMENT]: '/icons/unit.png',
      [AssetType.REPORT]: '/icons/unit.png',
      [AssetType.UNKNOWN]: '/icons/unit.png',
    };

    return iconMap[assetType] || '/icons/unit.png';
  }
}
